// Local development sign-in without Entra (ADR-017). Only the Vite dev server
// can turn this on: import.meta.env.DEV is false in every production build, so
// the bypass is compiled out there whatever VITE_DEV_AUTH_BYPASS says. The API
// has its own guards and decides who the request acts as.
export const DEV_AUTH_BYPASS = import.meta.env.DEV && import.meta.env.VITE_DEV_AUTH_BYPASS === 'true'
